module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/mute-828bc25e19267f2a7cd5e5ccb98695b1.svg";